// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"6787619c","65":"ed5bd531","106":"0f765923","147":"5e76aba0","208":"f00523b2","298":"51fef8f2","392":"4108fc0d","405":"c1626e52","499":"b18b594b","656":"34611859","680":"fcab64d3","830":"2a86e422"}[chunkId] + ".chunk.js";
};